import React from 'react'
import styled from 'styled-components'
import { BreadcrumbLink, BreadcrumbListItem } from '../UI'
import { IconChevronRightSmall } from '../../../Icons'
import { SEOBreadcrumbElementType, Link } from '@sentecacommerce-theme/lib'

export const BreadcrumbItemList = ({
  items,
}: {
  items: SEOBreadcrumbElementType[]
}) => {
  return (
    <>
      {items.map((item, i) => (
        <BreadcrumbListItem {...item.elementSeoProps} key={item.link}>
          <Link href={item.link} passHref>
            <BreadcrumbLink {...item.elementLinkSeoProps}>
              {i < items.length - 1 && <ChevronRightSmallIcon />}
              {item.name}
              {i < items.length - 1 && <ChevronRightSmallIconDesktop />}
            </BreadcrumbLink>
          </Link>
        </BreadcrumbListItem>
      ))}
    </>
  )
}

const ChevronRightSmallIcon = styled(IconChevronRightSmall).attrs({
  width: '1.8rem',
  height: '1.8rem',
  className: 'd-block d-lg-none',
})`
  transform: rotate(180deg);
`

const ChevronRightSmallIconDesktop = styled(IconChevronRightSmall).attrs({
  width: '1.8rem',
  height: '1.8rem',
  className: 'd-none d-lg-block',
})``
